// @file CommandBar callback functions used in actions

import { convertWallToTableFormat, revertWallConversion } from '@@/bits/command_bar/tours/table_format_release/actions'
import { captureException } from '@@/bits/error_tracker'
import { isAppUsing } from '@@/bits/flip'
import window from '@@/bits/global'

const COMMAND_AI_CALLBACKS = {
  convert_wall_to_table: convertWallToTableFormat,
  undo_wall_conversion: revertWallConversion,
} as const

/**
 * Registers CommandBar callbacks for AI-related actions.
 * This function adds callbacks that handle wall format conversion and reversion.
 * The callbacks are only registered if CommandBar is enabled and available.
 * Any errors during callback registration or execution are captured but not thrown.
 */
export function addCommandAICallbacks(): void {
  if (!isAppUsing('commandBar') || window.CommandBar == null) return

  try {
    Object.entries(COMMAND_AI_CALLBACKS).forEach(([key, callback]) => {
      window.CommandBar.addCallback(key, () => {
        callback().catch((error) => captureException(error))
      })
    })
  } catch (error) {
    captureException(error)
  }
}
